import styled from 'styled-components';

const ResponsiveMinMax = styled.div({
  display: 'grid',
  gridTemplateColumns: 'minmax(482px,976px)',
});

export { ResponsiveMinMax };
